export default __webpack_public_path__ + "static/our-articles-d5d9daa59ea41aba661218f9d34e8ddd.png";